document.addEventListener('DOMContentLoaded', function() {
  function CustomSlideoutDrawer() {
    let lastTrigger;

    function closeDrawers() {
      const openDrawers = document.querySelectorAll('.custom-slideout-drawer.open');
      if (!openDrawers.length) return false;

      openDrawers.forEach(drawer => drawer.classList.remove('open'));
      document.querySelectorAll('.custom-slideout-drawer-container.open').forEach(container => {
        container.classList.remove('open');
        container.style.zIndex = '';
      });
      document.body.classList.remove('overflow-hidden');

      if (lastTrigger && lastTrigger.isConnected) {
        if (lastTrigger.tabIndex < 0 && !lastTrigger.hasAttribute('tabindex')) {
          lastTrigger.setAttribute('tabindex', '-1');
        }
        lastTrigger.focus({ preventScroll: true });
      }
      lastTrigger = null;
      return true;
    }

    // Trigger open slideout
    const triggers = document.querySelectorAll('[data-slideout-trigger]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault(); // ✅ stop default link/button action

        const slideoutId = this.getAttribute('data-slideout-trigger');
        const drawerContainer = document.querySelector(`[data-slideout-id="${slideoutId}"] .custom-slideout-drawer-container`);
        const drawer = document.querySelector(`[data-slideout-id="${slideoutId}"] .custom-slideout-drawer`);

        if (drawerContainer && drawer) {
          console.log('Opening drawer:', slideoutId);
          drawer.classList.toggle('open');
          drawerContainer.classList.toggle('open');
          drawerContainer.style.zIndex = '2147483650';
          document.body.classList.toggle('overflow-hidden');
          lastTrigger = drawer.classList.contains('open') ? this : null;
        }
      });
    });

    // Close triggers
    const closeTriggers = document.querySelectorAll('[data-custom-slideout-drawer-close]');
    closeTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault(); // ✅ stop default button behavior here too

        closeDrawers();
      });
    });

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing) return;
      if (closeDrawers()) event.preventDefault();
    });
  }

  CustomSlideoutDrawer();
});
